export const CFrequencyQuestions = {
  es: [
    {
      question: "¿Cuáles son los beneficios de entrar a REMAX?",
      answer:
        "Entrar a REMAX te permite desarrollar tu propio negocio inmobiliario bajo un modelo probado a nivel mundial. Obtienes independencia, altos niveles de comisión, respaldo de marca, acceso a herramientas tecnológicas, formación continua y una red de colaboración tanto local como internacional.",
    },
    {
      question: "¿Cuál es la diferencia entre las oficinas REMAX?",
      answer:
        "Cada oficina REMAX es una franquicia independiente. Aunque todas operan bajo los mismos estándares y la misma marca, cada Broker Owner define su propuesta de valor, sus servicios complementarios y su cultura interna. Por eso es importante que evalúes qué oficina se alinea mejor con tus necesidades y objetivos.",
    },
    {
      question: "¿Qué es REMAX RD y cuál es la diferencia con las oficinas?",
      answer:
        "REMAX República Dominicana es la oficina regional que representa la marca en el país y da soporte a las franquicias. No operamos directamente con clientes ni tenemos agentes; nuestro rol es brindar soporte, supervisión, capacitación y desarrollo a los Brokers y a sus oficinas. Cada oficina REMAX es independiente en su operación y reclutamiento de agentes.",
    },
    {
      question: "¿Puedo ingresar sin experiencia en ventas?",
      answer:
        "Sí. Contamos con programas de formación continua y un acompañamiento inicial que te permitirá aprender sobre el negocio inmobiliario, las ventas y el funcionamiento del modelo. Lo más importante es tu actitud, disciplina y compromiso con tu propio crecimiento.",
    },
    {
      question: "¿Cuánto me paga REMAX?",
      answer:
        "En REMAX tú no eres un empleado, sino un agente independiente. Tu ingreso dependerá de las comisiones generadas por tus ventas o alquileres. Las oficinas REMAX ofrecen uno de los modelos de comisión más altos del mercado inmobiliario.",
    },
    {
      question:
        "¿Cómo funciona el esquema de comisión cuando vendo o alquilo una propiedad?",
      answer:
        "Cada vez que realizas una transacción, recibes un porcentaje de la comisión inmobiliaria que se cobra al cliente. Ese porcentaje depende del plan (split) que tengas contratado con tu oficina. Generalmente, los splits van desde un 50% hasta un 80% para el agente, lo que significa que tú conservas la mayor parte de tus ingresos. Esto te permite trabajar bajo un modelo donde, mientras más produces, mayor es tu rentabilidad.",
    },
    {
      question: "¿Por qué tengo que pagar para estar en REMAX?",
      answer:
        "Al ser un agente independiente y tener tu propio negocio bajo la marca REMAX, asumes ciertos costos operativos relacionados con el uso de la marca, las herramientas tecnológicas, la capacitación y el soporte que recibes. Este modelo permite que mantengas un porcentaje mayor de tus ingresos en comparación con otros modelos tradicionales.",
    },
    {
      question: "¿Cuál es la diferencia entre los splits de comisión?",
      answer:
        "Los splits son los planes que definen qué porcentaje de la comisión recibe el agente y qué porcentaje la oficina. A mayor split (por ejemplo, 80%), mayor es la cuota fija mensual, ya que te permite retener un mayor porcentaje de tus comisiones. Por el contrario, si eliges un split más bajo (como 50%), pagas una cuota mensual más reducida, pero la oficina retiene un porcentaje mayor de cada transacción. Este modelo te permite elegir el plan que más se adapte a tu etapa profesional, tu capacidad operativa y tus objetivos de ingresos.",
    },
    {
      question: "¿Cuál es la diferencia entre asociado senior y asociado junior?",
      answer:
        "El asociado junior trabaja siempre dentro de un equipo liderado por un asociado senior, quien le brinda apoyo y mentoría. Tiene un split menor y una cuota más baja. El asociado senior opera de forma independiente o puede liderar su propio equipo, accediendo a splits más altos y mayores beneficios.",
    },
    {
      question:
        "¿Cuál es la diferencia entre la cuota regional y la cuota de oficina?",
      answer:
        "La cuota regional es el pago que realizan todos los agentes asociados para tener acceso a las plataformas tecnológicas globales, capacitación continua, soporte regional y derechos de uso de la marca REMAX. La cuota de oficina cubre los servicios y recursos que ofrece cada franquicia local (espacio físico, acompañamiento, soporte administrativo, etc.).",
    },
    {
      question: "¿Cuánto dinero me voy a ganar dentro de REMAX?",
      answer:
        "Tu ingreso es ilimitado y depende exclusivamente de tu productividad. No existen topes de comisión ni limitaciones. Mientras más cierres, más ganas.",
    },
    {
      question: "¿Puedo cambiar de asociado junior a asociado senior?",
      answer:
        "Sí. Una vez cumplas con los requisitos establecidos por tu oficina (normalmente basados en tu nivel de producción o tiempo en la marca), puedes solicitar el cambio a un plan de asociado senior.",
    },
    {
      question: "¿Puedo cambiar de oficina luego de haber entrado?",
      answer:
        "Sí, puedes solicitar tu traslado a otra oficina REMAX dentro del país, siempre que cuentes con el acuerdo de ambos Broker Owners (el de tu oficina actual y el de la oficina a la que deseas trasladarte). Es indispensable estar al día con tus compromisos económicos y administrativos antes de realizar el cambio.",
    },
    {
      question: "¿Puedo cambiar de equipo luego de haber entrado?",
      answer:
        "Sí. Si dentro de tu oficina trabajas en un equipo y deseas cambiar a otro equipo o trabajar de manera independiente, puedes hacerlo siguiendo los lineamientos internos de tu oficina.",
    },
    {
      question:
        "¿Tengo que producir un mínimo de comisiones para permanecer en la marca?",
      answer:
        "No existe un mínimo de producción exigido desde la marca a nivel regional. Sin embargo, cada oficina puede establecer lineamientos internos para evaluar la productividad de sus agentes. Además, es importante considerar que, al ser un negocio independiente, debes generar ingresos que te permitan cubrir tus costos operativos.",
    },
    {
      question: "¿Qué pasa si no vendo en un mes?",
      answer:
        "No hay penalización por no vender en un mes. Lo único que debes mantener son tus cuotas fijas (regional y de oficina). Es un modelo que permite que tú gestiones tu tiempo y esfuerzo según tus objetivos personales.",
    },
    {
      question: "¿REMAX me da las propiedades para que las venda?",
      answer:
        "No. Tú eres responsable de captar tus propias propiedades y clientes. Sin embargo, trabajas en una red colaborativa donde puedes acceder a las propiedades que otros agentes tienen en exclusiva y comercializarlas, generando así mayores oportunidades de negocio.",
    },
    {
      question: "¿Puedo promocionar y vender las propiedades de otros agentes?",
      answer:
        "Sí. El modelo REMAX fomenta la colaboración. Puedes promocionar, mostrar y vender propiedades captadas por otros agentes de tu misma oficina o incluso de otras oficinas REMAX, compartiendo la comisión según los acuerdos establecidos.",
    },
    {
      question: "¿Tengo que cumplir un horario laboral?",
      answer:
        "No. Tú eres dueño de tu tiempo. No hay un horario establecido ni obligación de asistencia diaria. El modelo te ofrece flexibilidad total para organizar tu agenda según tus objetivos personales y profesionales.",
    },
  ],
  en: [
    {
      question: "What are the benefits of joining REMAX?",
      answer:
        "Joining REMAX lets you build your own real estate business under a globally proven model. You gain independence, high commission levels, brand backing, access to technology tools, continuous training, and a collaborative network both locally and internationally.",
    },
    {
      question: "What’s the difference between REMAX offices?",
      answer:
        "Each REMAX office is an independent franchise. While all operate under the same standards and brand, each Broker Owner defines the value proposition, complementary services, and internal culture. It’s important to evaluate which office best aligns with your needs and goals.",
    },
    {
      question: "What is REMAX RD and how does it differ from the offices?",
      answer:
        "REMAX Dominican Republic is the regional office that represents the brand in the country and supports the franchises. We do not work directly with clients nor have agents; our role is to provide support, oversight, training, and development to Brokers and their offices. Each REMAX office operates and recruits independently.",
    },
    {
      question: "Can I join without sales experience?",
      answer:
        "Yes. We have continuous training programs and initial onboarding to help you learn the real estate business, sales, and how the model works. Your attitude, discipline, and commitment to your own growth matter most.",
    },
    {
      question: "How much does REMAX pay me?",
      answer:
        "At REMAX you are not an employee; you are an independent agent. Your income depends on commissions generated by your sales or rentals. REMAX offices offer some of the highest commission models in the real estate market.",
    },
    {
      question:
        "How does the commission split work when I sell or rent a property?",
      answer:
        "Every time you close a transaction, you receive a percentage of the real estate commission charged to the client. That percentage depends on the split plan you have with your office. Splits typically range from 50% to 80% to the agent, which means you keep most of your earnings. The more you produce, the higher your profitability.",
    },
    {
      question: "Why do I have to pay to be in REMAX?",
      answer:
        "As an independent agent running your own business under the REMAX brand, you assume certain operating costs related to brand usage, technology tools, training, and the support you receive. This model lets you retain a larger share of your income compared to traditional models.",
    },
    {
      question: "What’s the difference between commission splits?",
      answer:
        "Splits define what percentage of the commission the agent receives and what percentage the office receives. Higher splits (e.g., 80%) come with a higher fixed monthly fee because they let you retain a larger percentage of your commissions. Conversely, a lower split (e.g., 50%) has a lower monthly fee but the office retains a larger percentage per transaction. This model lets you choose the plan that best fits your career stage, operating capacity, and income goals.",
    },
    {
      question: "What’s the difference between a senior associate and a junior associate?",
      answer:
        "A junior associate always works within a team led by a senior associate, who provides support and mentorship. They have a lower split and a lower monthly fee. A senior associate operates independently or can lead their own team, accessing higher splits and greater benefits.",
    },
    {
      question: "What’s the difference between the regional fee and the office fee?",
      answer:
        "The regional fee is paid by all associated agents to access global technology platforms, continuous training, regional support, and the right to use the REMAX brand. The office fee covers the services and resources offered by each local franchise (physical space, coaching, administrative support, etc.).",
    },
    {
      question: "How much money will I earn at REMAX?",
      answer:
        "Your income is unlimited and depends solely on your productivity. There are no commission caps or limitations. The more you close, the more you earn.",
    },
    {
      question: "Can I move from junior to senior associate?",
      answer:
        "Yes. Once you meet your office’s requirements (usually based on your production level or time with the brand), you can request to switch to a senior associate plan.",
    },
    {
      question: "Can I change offices after joining?",
      answer:
        "Yes, you can request a transfer to another REMAX office in the country, provided you have agreement from both Broker Owners (your current office and the one you wish to move to). It’s essential to be up to date with your financial and administrative commitments before making the change.",
    },
    {
      question: "Can I change teams after joining?",
      answer:
        "Yes. If you work in a team within your office and want to switch to another team or work independently, you can do so following your office’s internal guidelines.",
    },
    {
      question: "Do I have to meet a minimum production to remain with the brand?",
      answer:
        "There is no regionally mandated minimum. However, each office may set internal guidelines to evaluate agent productivity. Also remember that, as an independent business, you must generate income to cover your operating costs.",
    },
    {
      question: "What happens if I don’t sell in a given month?",
      answer:
        "There is no penalty for not selling in a month. You just need to keep up with your fixed fees (regional and office). The model allows you to manage your time and effort according to your personal goals.",
    },
    {
      question: "Does REMAX give me properties to sell?",
      answer:
        "No. You are responsible for sourcing your own listings and clients. However, you work within a collaborative network where you can access exclusive listings from other agents and market them, creating greater business opportunities.",
    },
    {
      question: "Can I promote and sell other agents’ listings?",
      answer:
        "Yes. The REMAX model encourages collaboration. You can promote, show, and sell properties listed by agents in your office or even in other REMAX offices, sharing the commission according to agreed terms.",
    },
    {
      question: "Do I have to keep fixed working hours?",
      answer:
        "No. You own your time. There is no set schedule or daily attendance requirement. The model offers total flexibility to organize your calendar according to your personal and professional goals.",
    },
  ],
};
